import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import FlatButton from 'material-ui/FlatButton'
import TextField from 'material-ui/TextField'
import Dialog from 'material-ui/Dialog'
import { Tab, Tabs } from 'material-ui/Tabs'
import Cropper from 'react-cropper'
import CircularProgress from 'material-ui/CircularProgress'
import Toggle from 'material-ui/Toggle'

import {
  closeAddLocationForm,
  updateField,
  updateLocation,
  cancelImage,
  changeImage,
  showSpinner,
  updateHasTv,
  updateBrivo
} from '../../actions/locations'

const styles = {
  sessionButton: {
    verticalAlign: 'middle'
  },
  uploadButton: {
    verticalAlign: 'middle'
  },
  uploadInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0
  },
  chip: {
    margin: 4,
    float: 'left'
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  tab: {
    minHeight: 400
  }
}
const BrivoOption = {
  BRIVO_1: 0,
  BRIVO_2: 1
}

const toggle = {
  marginLeft: 10
}

class AddLocation extends Component {
  static defaultProps = {
    showSpinner: false,
    brivoOptions: [{ value: BrivoOption.BRIVO_1, name: 'BRIVO 1' }, { value: BrivoOption.BRIVO_2, name: 'BRIVO 2' }]
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {}

  closeDialog() {
    const { dispatch } = this.props
    dispatch(closeAddLocationForm())
  }

  updateCompany(event, index, value) {
    const { dispatch } = this.props

    var company = {}

    if (value !== null) {
      company = this.props.companies.find(e => e._id === value)
    }

    dispatch(updateField('company', company))
  }

  updateBuilding(event, index, value) {
    const { dispatch } = this.props

    var building = {}

    if (value !== null) {
      building = this.props.buildings.find(e => e._id === value)
    }

    dispatch(updateField('building', building))
  }

  updateLocation() {
    this.showSpinner()
    const { dispatch } = this.props
    dispatch(updateLocation(this.props.currentLocation))
  }

  updateField(event) {
    const { dispatch } = this.props
    dispatch(updateField(event.target.name, event.target.value))
  }

  cancelImage(event) {
    const { dispatch } = this.props
    dispatch(cancelImage())
  }

  onImageChange(event) {
    const { dispatch } = this.props
    event.preventDefault()
    let files
    if (event.dataTransfer) {
      files = event.dataTransfer.files
    } else if (event.target) {
      files = event.target.files
    }
    const reader = new FileReader()
    reader.onload = () => {
      dispatch(changeImage(reader.result))
    }
    reader.readAsDataURL(files[0])
  }

  cropImage() {
    const { dispatch } = this.props

    if (typeof this.cropper.getCroppedCanvas() === 'undefined') {
      return
    }

    dispatch(changeImage(this.cropper.getCroppedCanvas().toDataURL()))
  }

  showSpinner() {
    const { dispatch } = this.props
    dispatch(showSpinner())
  }

  updateHasTv(name, event, enabled) {
    const { dispatch } = this.props
    dispatch(updateHasTv(name, enabled))
  }

  updateBrivo(event, index, value) {
    const { dispatch } = this.props
    dispatch(updateBrivo(value))
  }

  render() {
    if (this.props.currentLocation) {
      const actions = [
        <div>
          <FlatButton label='Cancel' primary={true} onClick={this.closeDialog.bind(this)} />
          {this.props.showSpinner ? (
            <CircularProgress
              style={{ paddingLeft: '71px', paddingRight: '71px', verticalAlign: 'middle' }}
              size={20}
              thickness={1}
            />
          ) : (
            <FlatButton
              id={'dialogAddLocation'}
              label={this.props.currentLocation._id == null ? 'Add Location' : 'Update Location'}
              primary={true}
              onClick={this.updateLocation.bind(this)}
            />
          )}
        </div>
      ]
      return (
        <Dialog actions={actions} title='Add Location' modal={true} open={this.props.currentLocation != null}>
          <Tabs>
            <Tab label='General Info'>
              <div style={styles.tab}>
                <TextField
                  name='name'
                  hintText='Name'
                  floatingLabelText='Name'
                  value={this.props.currentLocation.name}
                  onChange={this.updateField.bind(this)}
                />
                <br />
                <TextField
                  name='capacity'
                  hintText='Capacity'
                  floatingLabelText='Capacity'
                  value={this.props.currentLocation.capacity}
                  onChange={this.updateField.bind(this)}
                />
                <br />
                <SelectField
                  name='company'
                  floatingLabelText='Company'
                  onChange={this.updateCompany.bind(this)}
                  value={this.props.currentLocation.company ? this.props.currentLocation.company._id : ''}>
                  {this.props.companies.map((company, index) => (
                    <MenuItem
                      value={company._id}
                      primaryText={company.name}
                      checked={
                        this.props.currentLocation.company && this.props.currentLocation.company._id === company._id
                      }
                    />
                  ))}
                </SelectField>
                <br />
                {this.props.role.length > 5 && this.props.role.charAt(5) == '2' ? (
                  <TextField
                    name='accessPointId'
                    hintText='Access Point Id'
                    floatingLabelText='Access Point Id'
                    value={this.props.currentLocation.accessPointId}
                    onChange={this.updateField.bind(this)}
                  />
                ) : (
                  <div />
                )}
                <br />
                <SelectField
                  style={{ marginRight: '20px', float: 'left' }}
                  floatingLabelText='Brivo Credentials'
                  value={this.props.currentLocation.brivo}
                  name='brivo'
                  onChange={this.updateBrivo.bind(this)}>
                  {this.props.brivoOptions.map((option, index) => (
                    <MenuItem value={option.value} primaryText={option.name} />
                  ))}
                </SelectField>
                <br />
                <br />
                <br />
                <br />
                <SelectField
                  name='building'
                  floatingLabelText='Building'
                  onChange={this.updateBuilding.bind(this)}
                  value={this.props.currentLocation.building ? this.props.currentLocation.building._id : ''}>
                  {this.props.buildings.map((building, index) => (
                    <MenuItem
                      value={building._id}
                      primaryText={building.name}
                      checked={
                        this.props.currentLocation.building && this.props.currentLocation.building._id === building._id
                      }
                    />
                  ))}
                </SelectField>
                <br />
                <Toggle
                  toggled={this.props.currentLocation.hasTv}
                  label='Has Tv'
                  labelPosition='right'
                  style={toggle}
                  onToggle={this.updateHasTv.bind(this, 'hasTv')}
                />
              </div>
            </Tab>
            <Tab label='Description'>
              <div style={styles.tab}>
                <TextField
                  name='description'
                  hintText='Description'
                  floatingLabelText='Description'
                  multiLine={true}
                  rows={4}
                  rowsMax={4}
                  value={this.props.currentLocation.description}
                  onChange={this.updateField.bind(this)}
                />
                <br />
                <TextField
                  name='adminDescription'
                  hintText='Admin Description'
                  floatingLabelText='Admin Description'
                  multiLine={true}
                  rows={4}
                  rowsMax={4}
                  value={this.props.currentLocation.adminDescription}
                  onChange={this.updateField.bind(this)}
                />
              </div>
            </Tab>
            <Tab label='Image'>
              <div style={styles.tab}>
                <Cropper
                  style={{ height: 400, width: '100%' }}
                  aspectRatio={16 / 9}
                  guides={false}
                  src={
                    this.props.currentLocation.newImage
                      ? this.props.currentLocation.newImage
                      : this.props.currentLocation.detailsImage
                  }
                  ref={cropper => {
                    this.cropper = cropper
                  }}
                />
                <br />
                {this.props.currentLocation.newImage ? (
                  <FlatButton
                    fullWidth={true}
                    label='Cancel'
                    labelPosition='before'
                    style={styles.uploadButton}
                    containerElement='label'
                    onClick={this.cancelImage.bind(this)}
                  />
                ) : null}
                <br />

                <FlatButton
                  fullWidth={true}
                  label='Crop'
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'
                  onClick={this.cropImage.bind(this)}
                />
                <br />
                <FlatButton
                  fullWidth={true}
                  label={this.props.currentLocation.image ? 'Change Image' : 'Choose an Image'}
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'>
                  <input type='file' style={styles.uploadInput} onChange={this.onImageChange.bind(this)} />
                </FlatButton>
              </div>
            </Tab>
          </Tabs>
          <div style={{ color: 'red' }}>{this.props.error}</div>
        </Dialog>
      )
    } else {
      return <div />
    }
  }
}

const mapStateToProps = state => {
  return { ...state.locationsReducer, ...state.usersReducer }
}

export default withRouter(connect(mapStateToProps)(AddLocation))



// WEBPACK FOOTER //
// ./src/components/locations/AddLocation.js